// @flow

export { CashTips } from './cash-tips';
